import Vue from "vue";
import Vuex from "vuex";
import axios from "@/utils/axios-instance";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        count: 0,
        searchResults: null,
        searchQuery: null,
        searchRequest: null,
        user: null,
        appLoaded: false,
        workingOffer: null,
        editingOffers: [],
        editingOrders: [],
    },
    mutations: {
        increment (state) {
            state.count++
        },
        newSearchRequest(state) {
            state.searchRequest = axios.CancelToken.source();
        },
        setSearchResult(state, {searchResults, searchQuery}) {
            state.searchQuery = searchQuery;
            state.searchResults = searchResults;
            state.searchRequest = null;
        },
        setUser(state, {user}) {
            state.user = user;
        },
        setWorkingOffer(state, {workingOffer}) {
            state.workingOffer = workingOffer;
        },
        setEditingOffers(state, {editingOffers}) {
            state.editingOffers = editingOffers;
        },
        setEditingOrders(state, {editingOrders}) {
            state.editingOrders = editingOrders;
        },
        appLoaded(state) {
            state.appLoaded = true;
        }
    },
    actions: {
        async search ({ commit, state }, searchQuery) {
            if(state.searchRequest) {
                state.searchRequest.cancel();
            }
            commit('newSearchRequest');

            // Limit the search query to at least 3 characters
            if(!searchQuery || searchQuery.length < 3) {
                commit('setSearchResult', {
                    searchResults: null,
                    searchQuery: searchQuery,
                });
                return;
            }

            try {
                let response = await axios.get('search/', {
                    params: {query: searchQuery},
                    cancelToken: state.searchRequest.token,
                });

                commit('setSearchResult', {
                    searchResults: response.data,
                    searchQuery
                });
            } catch(e) {
                if (!axios.isCancel(e)) {
                    console.log("Search error!");
                    console.log(e);

                    commit('setSearchResult', {
                        searchResults: null,
                        searchQuery: null,
                    });
                }
            }
        },
        async reloadWorkingOffer({ commit }) {
            try {
                let response = await axios.get('offer/working-offer');

                commit('setWorkingOffer', {
                    workingOffer: response.data,
                });
            } catch(e) {
                if (!axios.isCancel(e)) {
                    console.log("Working offer retrieval error!");
                    console.log(e);

                    commit('setWorkingOffer', {
                        workingOffer: null,
                    });
                }
            }
        },
        async reloadEditingOffers({ commit }) {
            try {
                let response = await axios.get('offer/get-editing');

                commit('setEditingOffers', {
                    editingOffers: response.data,
                });
            } catch(e) {
                if (!axios.isCancel(e)) {
                    console.log("Editing offers retrieval error!");
                    console.log(e);

                    commit('setEditingOffers', {
                        editingOffers: [],
                    });
                }
            }
        },
        async reloadEditingOrders({ commit }) {
            try {
                let response = await axios.get('order/get-editing');

                commit('setEditingOrders', {
                    editingOrders: response.data,
                });
            } catch(e) {
                if (!axios.isCancel(e)) {
                    console.log("Editing orders retrieval error!");
                    console.log(e);

                    commit('setEditingOrders', {
                        editingOffers: [],
                    });
                }
            }
        },
        async authenticate({ commit, dispatch }) {
            let response = await axios.get('login/is-logged-in');
            if(response.data.logged_in) {
                commit('setUser', response.data);

                await dispatch('reloadWorkingOffer');
                await dispatch('reloadEditingOffers');
                await dispatch('reloadEditingOrders');
            }
        }
    },
    getters: {
        isLoggedIn: state => {
            return !!state.user
        },
        isSearching: state => {
            return !!state.searchRequest
        }
    }
})